import { httpClient } from '@/api/http-client'
import { PartnerMonthlyWithdraw } from '@/types'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

type Params = {
  companyKey: string
  partnerKey: string
  year: number
}

export const listPartnerMonthlyWithdraws = async ({
  companyKey,
  partnerKey,
  year = new Date().getFullYear(),
}: Params) => {
  const response = await httpClient('accounting-dealer').get(
    `/v3/company/${companyKey}/partner/${partnerKey}/monthly-withdraws`,
    {
      params: {
        year,
      },
    },
  )
  return response.data
}

export const useListPartnerMonthlyWithdraws = (
  { companyKey, partnerKey, year }: Params,
  options?: Partial<UseQueryOptions<PartnerMonthlyWithdraw[]>>,
) => {
  return useQuery({
    queryKey: ['partner-monthly-withdraws', companyKey, partnerKey, year],
    queryFn: () =>
      listPartnerMonthlyWithdraws({ companyKey, partnerKey, year }),
    staleTime: 0,
    ...options,
  })
}
